'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TabsComponent } from './component';
import { TabContentComponent } from './tabcontent/component';
import { TabComponent } from './tab/component';

@NgModule({
  imports     : [
    BrowserModule
  ],
  declarations: [TabsComponent, TabContentComponent, TabComponent],
  exports     : [TabsComponent, TabContentComponent, TabComponent]
})
export class LKTabs {
}
